import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import store  from './store/store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Provider store={store}>
      <App />
      <ToastContainer />
  </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
